// export const RootAPI = "http://172.30.47.118:5700/api/";
export const RootAPI = "https://staging-api.nec-fts.com/api/";
// export const PartnerAPI = 'http://127.0.0.1:8000/api/'
// export const RootAPI = 'https://172.30.47.118:5001/api/'
//export const RootAPI = 'https://172.30.47.118:5004/api/'
